import Vue from 'vue'
import Vuetify, {
  VApp
} from 'vuetify/lib'
import i18n from './i18n'
import 'vuetify/src/stylus/app.styl'

import { VDialog, VTextarea, VCard, VCardTitle, VCardText, VCardActions, VBtn } from 'vuetify/lib/components'

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  components: {
    VApp,
    VDialog,
    VTextarea,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VBtn
  },
  theme: {
    primary: '#3D91F7'
  }
})
